import { combineReducers } from 'redux';
import { Actions, ActionTypes } from './actions';

export const url = (state = '/' , action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.SET_REDIRECT_URL:
			return action.payload.url;
		default:
			return state;
	}
};

export interface IRedirectUrlState {
	url: ReturnType<typeof url>;
}

const redirect = combineReducers<IRedirectUrlState>({
	url
});

export default redirect;
